import React from 'react';
import { motion } from "framer-motion";
import js from '../Logos/js.png'
import node from '../Logos/node.png'
import express from '../Logos/express.png'
import mongo from '../Logos/mongo.png'
import react from '../Logos/react.png'

const Skills = () => {
    return (
        <div className='mt-24 bg-cyan-600 p-8 w-3/4 mx-auto rounded-md'>
            <h3 className='text-3xl text-white text-center font-bold font-mono'>CORE SKILLS</h3>
            <div className='grid grid-cols-1 lg:grid-cols-5 p-12 place-items-center'>
                <motion.div
                    className='rounded-md'
                    style={{ width: "80px", height: "80px" }}
                    animate={{ rotate: [0, 10, -10, 0], y: [0, -20, -20, 0] }}
                    transition={{ repeat: Infinity, duration: 4 }}
                >
                    <img className='rounded-lg' src={js} alt="" />
                </motion.div>
                <motion.div
                    className='rounded-md'
                    style={{ width: "120px", height: "120px" }}
                    animate={{ rotate: [0, 10, -10, 0], y: [0, 20, 20, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                >
                    <img className='rounded-lg' src={node} alt="" />
                </motion.div>
                <motion.div
                    className='rounded-md'
                    style={{ width: "130px", height: "130px" }}
                    animate={{ rotate: [0, 10, -10, 0], y: [0, 40, 40, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                >
                    <img className='rounded-lg' src={express} alt="" />
                </motion.div>
                <motion.div
                    className='rounded-md'
                    style={{ width: "150px", height: "150px" }}
                    animate={{ rotate: [0, 10, -10, 0], y: [0, 70, 70, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                >
                    <img className='rounded-lg' src={mongo} alt="" />
                </motion.div>
                <motion.div
                    className='rounded-md'
                    style={{ width: "80px", height: "80px" }}
                    animate={{ rotate: [0, 10, -10, 0], y: [0, 30, 30, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                >
                    <img className='rounded-lg' src={react} alt="" />
                </motion.div>
            </div>
        </div>
    );
};

export default Skills;